module.exports = __webpack_public_path__ + "static/logos/snow-forecast__logo-ce9a95ce9b84467f2e1dae9003bcf970.svg";